$('.companies.right a[desc!=""]').hover(
    (e) => {
        let item = $(e.currentTarget);
        item.data['detail'] = $('<div class="detail">' + item.attr('desc') + '<div class="arrow"></div></div>');
        item.append(item.data['detail']);
        var top = (item.data['detail'].outerHeight() - item.outerHeight()) / 2;
        item.data['detail'].css('top', -top);
    },
    (e) => {
        let item = $(e.currentTarget);
        item.data['detail'].remove();
    }
);
